import { SearchParams } from '@/types/common'
import { CreateLocation, UpdateLocation } from '@/types/location'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const locationApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/location'
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getBySiteId(siteId?: string, searchParams: SearchParams = {}) {
    const url = `/api/location/${siteId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  checkFloorOverlay(interfaceId?: string) {
    const url = `/api/flooroverlay/is-exist?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },
  getById(interfaceId?: string, id?: string) {
    const url = `/api/location/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateLocation) {
    const url = '/api/location'
    return axiosClient.post(url, payload)
  },
  delete(interfaceId: string, id: string) {
    const url = `/api/location/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateLocation) {
    const url = '/api/location'
    return axiosClient.put(url, payload)
  },
}

export default locationApi
